import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  role: string;
  location: string;
  headline: string;
  body: string;
  highlight: string;
}
const testimonials: Testimonial[] = [{
  initials: 'AR',
  name: 'Andrés R.',
  role: 'Gerente de Proyectos',
  location: 'Bogotá, Colombia',
  headline: 'Por primera vez, mi jefe me preguntó mi opinión.',
  body: 'Llevaba dos años siendo el "buen empleado" al que todos le pasaban trabajo extra. Apliqué el Protocolo de Escudo Cognitivo y, en menos de tres semanas, los compañeros que me usaban dejaron de hacerlo. No tuve que pelear con nadie. Solo cambié cómo respondía.',
  highlight: 'Tres semanas'
}, {
  initials: 'MC',
  name: 'María Camila V.',
  role: 'Emprendedora · Agencia Digital',
  location: 'Ciudad de México',
  headline: 'Detecté a un socio tóxico antes de firmar.',
  body: 'El Radar de Intenciones fue lo que más me sirvió. Estaba a punto de cerrar un acuerdo con alguien que parecía perfecto sobre el papel. Las técnicas del libro me ayudaron a leer entre líneas y ver lo que realmente quería de mí. Me ahorró miles de dólares y un dolor de cabeza enorme.',
  highlight: 'Radar de Intenciones'
}, {
  initials: 'JP',
  name: 'Javier P.',
  role: 'Abogado',
  location: 'Madrid, España',
  headline: 'No es manipulación. Es legítima defensa.',
  body: 'Compré el libro esperando algo turbio y me encontré con todo lo contrario: un manual para dejar de ser ingenuo. Las 7 Leyes de la Psicología Oscura no se tratan de atacar a nadie, se tratan de no ser presa fácil. En mi profesión, eso vale oro.',
  highlight: 'Las 7 Leyes'
}, {
  initials: 'LS',
  name: 'Lucía S.',
  role: 'Diseñadora · Freelance',
  location: 'Buenos Aires, Argentina',
  headline: 'La gente empezó a tratarme distinto sin que dijera nada.',
  body: 'Lo más sorprendente fue lo rápido que funcionó. Apliqué la Neutralidad del Observador en una reunión familiar complicada y, sin discutir ni gritar, sentí que el aire en la habitación cambió. Hice la auditoría social y entendí quiénes me drenaban energía. Recomendado al 100%.',
  highlight: 'Neutralidad del Observador'
}];
function Stars() {
  return <div className="flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-229">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} size={14} className="text-blood fill-blood" strokeWidth={0} data-id="element-230" />)}
    </div>;
}
export function Testimonials() {
  return <Section className="max-w-6xl" data-id="element-231">
      <div className="text-center mb-14" data-id="element-232">
        <span className="text-blood font-sans text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-233">
          Lectores reales · Resultados reales
        </span>
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-foreground" data-id="element-234">
          Lo que están diciendo quienes ya cruzaron al otro lado
        </h2>
        <div className="h-[1px] w-12 bg-blood mx-auto mb-6" data-id="element-235"></div>
        <p className="text-foreground/60 font-sans font-light max-w-2xl mx-auto" data-id="element-236">
          Más de mil lectores han aplicado el método. Estos son algunos de los
          testimonios que nos llegan cada semana.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-237">
        {testimonials.map((t, index) => <motion.article key={t.name} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} className="relative p-7 md:p-8 border border-border bg-dark group hover:border-blood/40 transition-colors duration-300" data-id="element-238">
            <Quote size={36} className="absolute top-5 right-5 text-blood/15" strokeWidth={1} aria-hidden="true" data-id="element-239" />

            <div className="flex items-center justify-between mb-5" data-id="element-240">
              <Stars data-id="element-241" />
              <span className="text-foreground/40 font-sans text-[10px] uppercase tracking-widest" data-id="element-242">
                Compra verificada
              </span>
            </div>

            <h3 className="text-xl md:text-2xl font-serif font-bold text-foreground mb-4 leading-snug pr-6" data-id="element-243">
              "{t.headline}"
            </h3>

            <p className="text-foreground/70 font-sans font-light leading-relaxed mb-6 text-[15px]" data-id="element-244">
              {t.body}
            </p>

            <div className="h-[1px] w-8 bg-blood/60 mb-5" data-id="element-245"></div>

            <div className="flex items-center gap-4" data-id="element-246">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-blood/10 border border-blood/30 flex items-center justify-center" data-id="element-247">
                <span className="font-serif font-bold text-blood text-sm" data-id="element-248">
                  {t.initials}
                </span>
              </div>
              <div data-id="element-249">
                <p className="font-sans font-semibold text-foreground text-sm" data-id="element-250">
                  {t.name}
                </p>
                <p className="text-foreground/50 font-sans text-xs" data-id="element-251">
                  {t.role} · {t.location}
                </p>
              </div>
            </div>
          </motion.article>)}
      </div>
    </Section>;
}